import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as appActions from "../../core/app.store";

import HomeNewsView from './news/news.view';
import HomeSliderView from "./slider/slider.view";
// import HomeSearchView from "./search/search.view"
// import HomeLinkView from "./link/link.view"
import "./home.scss";
import IframeVR360 from "./embeded-vr360";
import NewsCategoryView from "./news-category/news-category.view";
import * as newsActions from "../../redux/store/news/news.store";

function HomeDesktop(props) {
  const [newsCategoriesModel, setNewsCategoriesModel] = useState([]);
  const { showLoading } = props;

  const getLookupNewsCategories = () => {
    showLoading(true);
    return new Promise((resolve, reject) => {
      newsActions.GetLookupNewsCategories()
        .then((res) => {
          if (res && res.content && res.content.length > 0) {
            setNewsCategoriesModel(res.content);
          } else {
            setNewsCategoriesModel([]);
          }
          resolve(res);
        })
        .catch((err) => reject(err))
        .finally(() => {
          showLoading(false);
        });
    });
    // setNewsCategoriesModel(["contest_info", "idea_planning"])
  }

  useEffect(() => {
    getLookupNewsCategories();
  }, [])

  return (
    <div className="home-page">
      <HomeSliderView />
      {/* <IframeVR360 /> */}
      {/* <HomeNewsView /> */}
      <div>
        {newsCategoriesModel.length > 0 && newsCategoriesModel.reverse().map((item, index) => {
          if (item.id == 1 || item.id == 2) {
            return <NewsCategoryView title={item.name} categoryId={item.id} index={index} />
          }
        })}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showLoading: appActions.ShowLoading,
    },
    dispatch
  );

export default  (connect(mapStateToProps, mapDispatchToProps)(HomeDesktop));
